module.exports = "/_next/static/images/healthier-choice-illustration-af5c122c969bb10ab2a5b16c93a3c9e4.svg";